"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageQuoteGrid2Tab = void 0;
var react_1 = __importDefault(require("react"));
var crumbs_1 = require("../crumbs");
var quotetable_1 = require("../quotetable");
require("./page.less");
var refresh_1 = require("../refresh");
var maintab_1 = require("./shared/maintab");
/**
 * 行情表格页面带二级tab
 * @returns
 */
function PageQuoteGrid2Tab() {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "page_head_crumbs scf" },
            react_1.default.createElement("div", { className: "c" },
                react_1.default.createElement(crumbs_1.Crumbs, null)),
            react_1.default.createElement("div", { className: "r" },
                react_1.default.createElement(refresh_1.RefreshBtn, null))),
        react_1.default.createElement(maintab_1.MainTab2, null),
        react_1.default.createElement(quotetable_1.QuoteTable, { mt: 10 })));
}
exports.PageQuoteGrid2Tab = PageQuoteGrid2Tab;
